import React from "react";
import { Data } from "../../../store/audit/types";
import { has } from "lodash";
import { makeStyles } from "@mui/styles";
import { ArrowForwardRounded } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

interface RowProps {
  row: Data;
}

interface ListItemProps {
  label: string;
  objectValue: any;
  level: number;
}

const ListItem = ({ label, objectValue, level }: ListItemProps) => {
  let children;

  const onCopyValue = (value: string) => {
    navigator.clipboard.writeText(value);
  };
  if (has(objectValue, "FromDisplay") && has(objectValue, "ToDisplay")) {
    children = (
      <span className="value">
        <Tooltip title="click to copy" arrow>
          <span
            className="fromValue"
            onClick={() => onCopyValue(objectValue.FromValue)}
          >{`${objectValue.FromDisplay}`}</span>
        </Tooltip>

        <span className="arrow">
          <ArrowForwardRounded />
        </span>
        <Tooltip title="click to copy" arrow>
          <span
            className="toValue"
            onClick={() => onCopyValue(objectValue.ToValue)}
          >{`${objectValue.ToDisplay}`}</span>
        </Tooltip>
      </span>
    );
  } else {
    const newLevel = level + 1;
    const sorted = Object.keys(objectValue)
      .sort()
      .reduce((accumulator: any, key) => {
        accumulator[key] = objectValue[key];

        return accumulator;
      }, {});
    children = (
      <ul className="value">
        {Object.keys(sorted).map((key) => (
          <ListItem
            key={key}
            label={key}
            objectValue={objectValue[key]}
            level={newLevel}
          />
        ))}
      </ul>
    );
  }
  return (
    <li>
      <span className={`label level-${level}`}>{label} </span>
      {children}
    </li>
  );
};

export default function AuditDetail(props: RowProps): React.ReactElement {
  const { row } = props;
  const { dataDetail } = row;

  const useStyles = makeStyles({
    parent: {
      listStyleType: "none",

      "& > li span.label": {
        width: "30%",
        display: "inline-block",
        fontSize: "1rem",
        fontWeight: "700",
      },
      "& > li ul": {
        listStyleType: "none",
      },
      "& > li ul.value": {
        paddingLeft: "0",
      },
      "& > li span.value": {
        width: "55%",
        fontSize: "1rem",
        display: "inline-flex",
        alignItems: "center",
      },
      "& > li span.value span.fromValue": {
        width: "40%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textAlign: "right",
        textOverflow: "ellipsis",
        cursor: "pointer",
      },
      "& > li span.value span.arrow": {
        width: "10%",
        paddingLeft: "20px",
        "& > svg": {
          color: "#228B22",
        },
      },
      "& > li span.value span.toValue": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        width: "40%",
        textOverflow: "ellipsis",
        textAlign: "left",
        cursor: "pointer",
      },
      "& > li span.level-1": {
        textIndent: "0px",
      },
      "& > li span.level-2": {
        textIndent: "30px",
      },
      "& > li span.level-3": {
        textIndent: "60px",
      },
      "& > li span.level-4": {
        textIndent: "90px",
      },
      "& > li span.level-5": {
        textIndent: "120px",
      },
    },
  });

  const classes = useStyles();
  const sorted = Object.keys(dataDetail)
    .sort()
    .reduce((accumulator: any, key) => {
      accumulator[key] = dataDetail[key];

      return accumulator;
    }, {});
  return (
    <>
      <ul className={classes.parent}>
        {Object.keys(sorted).map((key) => (
          <ListItem key={key} label={key} objectValue={sorted[key]} level={1} />
        ))}
      </ul>
    </>
  );
}
